'use client';
import { GREY_800 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const Attachments = styled.div`
  text-align: right;
  color: ${GREY_800};
  flex-grow: 100;
  flex-basis: 0;
  flex-shrink: 0;
`;

export default Attachments;
